export default __webpack_public_path__ + "static/sig_01-411eb947e0a5cca5c8521b52229b17fd.png";